import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import SEO from "components/SEO";

const SkeletonMarketDetail = ({ headUrl, headTitle, headDesc }) => {
  return (
    <div className="w-full">
      <SEO url={headUrl} title={headTitle} desc={headDesc} />
      <div className="w-full">
        <div className="page-content w-full pt-12 pb-36">
          <div className="aiso-card shadow-md">
            {/* 헤더 */}
            <div>
              <div className="sm:flex justify-between items-start border-b border-ddd p-3">
                <div className="flex justify-start items-start">
                  <Skeleton animation="wave" variant="circle" width={40} height={40} />
                  <div className="pl-3 mt-0">
                    <Skeleton animation="wave" height={20} width={80} />
                    <Skeleton animation="wave" height={20} width={100} />
                  </div>
                </div>

                {/* 아이콘 영역 */}
                <div className="flex justify-end pt-2 sm:pt-0">
                  <div className="mr-3">
                    <Skeleton animation="wave" variant="rect" height={20} width={20} />
                  </div>
                  <div className="mr-3">
                    <Skeleton animation="wave" variant="rect" height={20} width={20} />
                  </div>
                  <div>
                    <Skeleton animation="wave" variant="rect" height={20} width={20} />
                  </div>
                </div>
              </div>
            </div>
            {/* 앱 이름 & 가격 */}
            <div className="w-full px-6 lg:px-32 py-3">
              <div className="pt-2 pb-4 sm:flex justify-between items-start">
                <p className="text-lg font-bold text-333 font-gmarket-medium break-all sm:pr-5">
                  <Skeleton animation="wave" height={20} width={100} />
                </p>
                <p className="text-xs text-333 font-gmarket-medium font-bold min-w-max flex justify-end items-center">
                  <Skeleton animation="wave" height={20} width={100} />
                </p>
              </div>
            </div>
            {/* 앱 샘플 파일 나타내기 */}
            <div className="w-full px-6 lg:px-32 py-3">
              <div>
                <div className="aiso-card-img pb-0">
                  <Skeleton animation="wave" variant="rect" height={200} width="100%" />
                  <Skeleton animation="wave" variant="rect" height={200} width="100%" />
                </div>

                {/* preview File list */}
                <div className="w-full md:flex mt-2">
                  {/* INPUT FILE AREA */}
                  <div className="w-full md:w-1/2 h-1/2 mr-1">
                    <Skeleton animation="wave" variant="rect" height={30} width="100%" />
                  </div>

                  {/* OUTPUT FILE AREA */}
                  <div className="w-full md:w-1/2 h-1/2">
                    <Skeleton animation="wave" variant="rect" height={30} width="100%" />
                  </div>
                </div>
              </div>
            </div>
            {/* 앱 설명 */}
            <div className="w-full px-6 lg:px-32 pt-3">
              <Skeleton animation="wave" variant="rect" height={30} width="100%" />
            </div>

            {/* LICENSE 표시 */}
            <div className="w-full px-6 lg:px-32 pt-3">
              <Skeleton animation="wave" variant="rect" height={30} width="100%" />
            </div>
            {/* 앱 실행 공간 */}
            <div className="w-full px-6 lg:px-32 py-3">
              {/* 앱 파라미터 데이터 작업 */}
              <div className="w-full mt-2">
                <div className="w-full flex flex-col center">
                  <div className="w-full mt-2">
                    {/* 파일 업로드 */}
                    <div className="row relative">
                      {/* inputType 배열 길이의 Dropzone  */}
                      <div className="w-full flex flex-col center">
                        <section className="w-full mx-3 mb-3 sm:w-4/6">
                          <div className="w-full">
                            <Skeleton animation="wave" height={40} width="100%" />
                            <Skeleton animation="wave" height={40} width="100%" />
                          </div>
                        </section>
                      </div>
                    </div>
                    {/* 실행 공간 */}
                    <div className="w-full flex flex-col items-center justify-center">
                      <div className="w-full flex items-center justify-center">
                        <Skeleton animation="wave" variant="rect" height={50} width="100%" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonMarketDetail;
